(function(doc, win) {
  if (window.__REM_LOADED__) return
  window.__REM_LOADED__ = true

  var docEl = doc.documentElement
  var resizeEvt =
    'orientationchange' in window ? 'orientationchange' : 'resize'
  var recalc = function() {
    var clientWidth = docEl.clientWidth
    if (!clientWidth) return
    if (clientWidth <= 1920) {
      docEl.style.fontSize = 10 * (clientWidth / 1920) + 'px'
    } else {
      docEl.style.fontSize = '11px'
    }
  }

  // 手动检查文档加载状态
  if (doc.readyState === 'complete') {
    recalc()
  } else {
    win.addEventListener('load', recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  }

  win.addEventListener(resizeEvt, recalc, false)
})(document, window)
